<div class="tabs">
  <div (click)="toggle('tab')" *ngFor="let tab of tabs" [ngClass]="{'active-tab': tab.select}" class="tab">{{tab.name}}
    <span class="tab-select-count">({{tab.count}})</span>
  </div>
</div>
